import { useMutation } from "@tanstack/react-query";
import { instance2 } from "../fetch";

const extractDataFromPDFForm = async (formData: FormData) => {
  if (!formData) return null;
  const response = await instance2.post(
    `/onboard/extract-form-from-image`,
    formData,
  );

  const normalisedData = JSON.parse(response.data?.output || "");
  return normalisedData;
};

export const useExtractDataFromPDFForm = () => {
  return useMutation({
    mutationFn: extractDataFromPDFForm,
  });
};
